<template>
  <v-dialog v-model="show" width="900px" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" small color="white" class="primary--text">
        <v-icon left>
          mdi-information-outline
        </v-icon>
        Take the tour
      </v-btn>
    </template>
    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step step="1">
          Import your Devices
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="2">
          Upload Firmware
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="3">
          Dowload status in Real-Time
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="4">
          Read our Documentation
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <p class="mx-3">
            After importing from your Firebase project, your devices will
            display on the Dashboard. Useful information such as Online/Offline
            status, Battery Voltage and WiFi RSSI will display by default.
          </p>
          <v-img
            class="rounded-lg ma-3 elevation-4"
            src="@/assets/docs/dashboard.png"
            contain
          ></v-img>
          <v-divider></v-divider>
          <v-row class="ma-4">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="e1 = 2">
              Next
            </v-btn>
          </v-row>
        </v-stepper-content>

        <v-stepper-content step="2">
          <p class="mx-3">
            Choose a device and select the upload button. You can upload your
            compiled firmware in
            <span class="font-weight-bold">.bin</span> format. Your file will be
            uploaded** and your ESP will download on next wake.
          </p>
          <p class="mx-3 caption">
            **Uploaded Firmwares are held on our server and automatically
            deleted at midnight each day. This is the only data we store.
          </p>
          <v-img
            class="rounded-lg mb-3"
            src="@/assets/docs/upload.png"
            contain
          ></v-img>
          <v-divider></v-divider>
          <v-row class="ma-4">
            <v-btn color="primary" @click="e1 = 1">
              Back
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="e1 = 3">
              Next
            </v-btn>
          </v-row>
        </v-stepper-content>

        <v-stepper-content step="3">
          <p>
            ~ After file upload, status is set to
            <span class="font-weight-bold">Pending</span>.
          </p>
          <v-img
            class="rounded-lg ma-3 elevation-4"
            src="@/assets/docs/pending.png"
            contain
          ></v-img>
          <p>
            ~ Download intialized by ESP. Status is set to
            <span class="font-weight-bold">Downloading</span>
          </p>
          <v-img
            class="rounded-lg ma-3 elevation-4"
            src="@/assets/docs/downloading.png"
            contain
          ></v-img>
          <p>
            ~ Once ESP has completed download, status is set as
            <span class="font-weight-bold">Up To Date</span>
          </p>
          <v-img
            class="rounded-lg ma-3 elevation-4"
            src="@/assets/docs/uptodate.png"
            contain
          ></v-img>
          <p>
            ~ If an error during download occurs, ESP will set status as
            <span class="font-weight-bold">Error</span>
          </p>
          <v-img
            class="rounded-lg ma-3 elevation-4"
            src="@/assets/docs/error.png"
            contain
          ></v-img>
          <v-divider></v-divider>
          <v-row class="ma-4">
            <v-btn color="primary" @click="e1 = 2">
              Back
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="e1 = 4">
              Next
            </v-btn>
          </v-row>
        </v-stepper-content>

        <v-stepper-content step="4">
          <v-row>
            <v-col class="text-center mb-4">
              <p>
                Read our Documentation to get setup and to download our ESP
                Firmwares.
              </p>
              <v-btn color="primary" @click="docs">
                <v-icon left small>mdi-school-outline</v-icon>
                Documentation
              </v-btn>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row class="ma-4">
            <v-btn color="primary" @click="e1 = 3">
              Back
            </v-btn>
            <v-spacer></v-spacer>
            <v-checkbox
              class="mr-4 mt-0"
              v-model="checkbox"
              label="Don't show this message again."
            ></v-checkbox>
            <v-btn color="primary" @click="close">
              Finished
            </v-btn>
          </v-row>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      checkbox: false,
      e1: 1,
    };
  },
  created: function() {
    const intro = this.$store.state.intro;
    if (intro !== false) {
      this.show = true;
    } else {
      this.checkbox = true;
    }
  },
  methods: {
    async close() {
      try {
        if (this.checkbox) {
          await this.$store.commit("setIntro", false);
          this.show = false;
        } else {
          await this.$store.commit("setIntro", true);
          this.show = false;
        }
        this.e1 = 1;
      } catch {
        console.log("error");
      }
    },

    docs() {
      this.close();
      this.$router.push({ name: "docs" });
    },
  },
};
</script>
